import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const ITEMS = [
  "Wake Up Refreshed",
  "24K Gold",
  "Deep Hydration",
  "60 Eye Patches",
  "Cooling Hydrogel",
  "At-Home Ritual",
  "Collagen Infused",
];

export const EditorialMarquee = () => (
  <div className="border-y border-champagne/70 bg-white/60 py-5" data-testid="editorial-marquee">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="mx-8 inline-flex items-center gap-8">
          <span className="font-display italic text-2xl text-ink/80 whitespace-nowrap">{item}</span>
          <Sparkle size={14} className="text-gold" strokeWidth={1.5} />
        </span>
      ))}
    </Marquee>
  </div>
);
